import { getFormattedPhoneNumber } from '../../../../../utils/phone.utils';

export const getAddress = (address: any): any => {
  if (!address) {
    return '';
  }

  const addressLine = address?.line?.[0] || '';
  const city = address?.city || '';
  const state = address?.state || '';
  let zip = address?.postalCode || '';

  // Remove any null or undefined values from the zip code
  if (zip) {
    zip = zip
      ?.split('-')
      ?.filter((zipCode) => zipCode !== 'null' && zipCode !== 'undefined')
      ?.join('-');
  }

  if (!addressLine && !city && !state && !zip) {
    return '';
  }

  return `${addressLine}, ${city}, ${state} ${zip}`.trim();
};

export type HourOfOperation = {
  day: string;
  openingTime: string;
  closingTime: string;
};

export type ModifiedHourOfOperation = {
  day: string;
  timing: string;
};

export const getHoursOfOperation = (
  hoursOfOperation: HourOfOperation[] = [],
  translation: any = () => {}
): ModifiedHourOfOperation[] => {
  const allDaysNotAvailable = hoursOfOperation?.every(
    (day) => day?.openingTime === '' && day?.closingTime === ''
  );

  if (!hoursOfOperation || allDaysNotAvailable) {
    return [
      {
        day: 'Mon, Tue, Wed, Thu',
        timing: translation('PROVIDER_LOCATIONS_DETAILS.NOT_AVAILABLE_UNKNOWN'),
      },
      {
        day: 'Fri',
        timing: translation('PROVIDER_LOCATIONS_DETAILS.NOT_AVAILABLE_UNKNOWN'),
      },
      {
        day: 'Sat, Sun',
        timing: translation('PROVIDER_LOCATIONS_DETAILS.NOT_AVAILABLE_UNKNOWN'),
      },
    ];
  }

  const result: any[] = [];
  const dayGroups = {
    Mon: ['monday'],
    Tue: ['tuesday'],
    Wed: ['wednesday'],
    Thu: ['thursday'],
    Fri: ['friday'],
    Sat: ['saturday'],
    Sun: ['sunday'],
  };

  const groupedDays: Record<string, string[]> = {};

  for (const [groupName, days] of Object.entries(dayGroups)) {
    const firstDayData = hoursOfOperation?.find(
      (item) => item?.day?.toLowerCase() === days[0]
    );

    const timing =
      firstDayData && firstDayData?.openingTime && firstDayData?.closingTime
        ? `${formatTime(firstDayData?.openingTime)} - ${formatTime(
            firstDayData?.closingTime
          )}`
        : translation('PROVIDER_LOCATIONS_DETAILS.NOT_AVAILABLE_UNKNOWN');

    if (!groupedDays[timing]) {
      groupedDays[timing] = [];
    }
    groupedDays[timing].push(groupName);
  }

  for (const [timing, days] of Object.entries(groupedDays)) {
    result.push({
      day: days.join(', '),
      timing,
    });
  }

  return result;
};

export const getObjectStringParsed = (
  resutls: { id: string; value: string }[],
  translation: any = () => {}
): string => {
  if (!resutls || resutls.length === 0) {
    return translation('PROVIDER_LOCATIONS_DETAILS.NOT_AVAILABLE_UNKNOWN');
  }
  return resutls.map((result) => result.value).join(', ');
};

export const getFacilitySpecialities = (
  facilityProgramIds: any[],
  translation: any = () => {}
): string => {
  if (!facilityProgramIds || facilityProgramIds.length === 0) {
    return translation('PROVIDER_LOCATIONS_DETAILS.NOT_AVAILABLE_UNKNOWN');
  }

  return facilityProgramIds.map((result) => result.title).join(', ');
};

export const getCostIndicatorDescription = (
  costIndicator: string,
  translation: any = () => {}
): string => {
  switch (costIndicator) {
    case '$':
      return translation('COST.BELOW_AVERAGE');
    case '$$':
      return translation('COST.AVERAGE');
    case '$$$':
      return translation('COST.ABOVE_AVERAGE');
    default:
      return '';
  }
};

const formatTime = (time: string): string => {
  if (!time) return '';
  const [hour, minute] = time.split(':').map(Number);
  const period = hour >= 12 ? 'PM' : 'AM';
  const formattedHour = hour % 12 || 12;
  return `${formattedHour}:${minute.toString().padStart(2, '0')} ${period}`;
};

export const getPhoneNumbers = (faxNumbers: string[]): string => {
  if (!faxNumbers || faxNumbers.length === 0) return '';

  return faxNumbers
    .map((faxNumber) => getFormattedPhoneNumber(faxNumber))
    .join(', ');
};
